import { type TransferReasonCode } from "@/features/salesforceIntegration/types";

/**
 * 確認ダイアログの内訳に出す、除外理由の短いラベル。
 *
 * 判定APIの`reasonMessage`はリクエスト単位の文章として書かれており、物件単位の
 * 内訳に並べると文意が合わない。たとえば`ALREADY_TRANSFERRED`は
 * 「連携できる物件はすべて連携済みです。」だが、他に送る物件がある場面でも出るため、
 * そのまま並べると「すべて」と送信件数が矛盾して見える。
 *
 * そこで内訳のラベルだけ`reasonCode`から引く。`reasonCode`はAPI境界のzodで
 * 列挙が検証されており、未知の値はここへ届かない。バックエンドが理由を増やしたら
 * 検証で落ちるため、この対応表が黙って古くなることはない。
 */
const EXCLUDED_REASON_LABELS: Record<TransferReasonCode, string> = {
  NOT_CONNECTED: "Salesforceと未接続",
  REAUTHORIZATION_REQUIRED: "再認証が必要",
  NO_SALESFORCE_RECORD: "Salesforce起点の依頼ではない",
  PICTURE_REQUEST_IN_PROGRESS: "登記取得が未完了",
  ANALYSIS_IN_PROGRESS: "解析が未完了",
  ANALYSIS_FAILED: "解析が失敗",
  NO_TRANSFERABLE_REAL_ESTATE: "連携できる登記がない",
  EXCEEDS_MAX_COUNT: "上限を超過",
  TRANSFER_IN_PROGRESS: "連携が実行中",
  ALREADY_TRANSFERRED: "連携済み",
};

/**
 * 除外理由を内訳用の短いラベルにする。
 * `reasonCode`が無い場合だけ、バックエンドの文言をそのまま使う。
 */
export const excludedReasonLabel = (
  reasonCode: TransferReasonCode | null,
  reasonMessage: string
): string =>
  reasonCode === null ? reasonMessage : EXCLUDED_REASON_LABELS[reasonCode];
